import { AssignmentActionNames, SetAssignmentPageStatus, SetCurrentAssignment, UnsetCurrentAssignment } from './types';
import { Assignment } from 'types/assignment';
import { PageStatus } from 'types/assignmentList';

export const setCurrentAssignmentAction = (updatedAssignment: Assignment): SetCurrentAssignment => ({
  type: AssignmentActionNames.SET_CURRENT_ASSIGNMENT,
  payload: updatedAssignment
});

export const unsetCurrentAssignmentAction = (): UnsetCurrentAssignment => ({
  type: AssignmentActionNames.UNSET_CURRENT_ASSIGNMENT
});

export const setAssignmentPageStatusAction = (pageStatus: PageStatus): SetAssignmentPageStatus => ({
  type: AssignmentActionNames.SET_ASSIGNMENT_PAGE_STATUS,
  payload: pageStatus
});
